import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Keep native events inside React Router. WebView canGoBack also includes
// document loads and entries with no router index, which are not app screens.
export default function NativeNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const native = window.jaosveNative;
    if (!native) return undefined;
    return native.attachNavigation({
      open(path) {
        if (path !== location.pathname + location.search) navigate(path);
      },
      back() {
        if (location.pathname === '/' && !location.search) {
          native.minimize();
          return;
        }
        const index = window.history.state?.idx;
        if (Number.isInteger(index) && index > 0) navigate(-1);
        else if (location.pathname !== '/' || location.search) navigate('/', { replace: true });
        else native.minimize();
      },
    });
  }, [location.pathname, location.search, navigate]);
  return null;
}
